import React, { useEffect, useState } from "react";
import { APP_THEME } from "../theme/theme";
import Header from "../components/header";
import BottomNav from "../components/bottom-menu";
import { apiCall } from "../utils/api";
import toast, { Toaster } from 'react-hot-toast';

function Margin() {
    const [loading, setLoading] = useState(true);
    const [mobileOperators, setMobileOperators] = useState([]);
    const [dthOperators, setDthOperators] = useState([]);

    useEffect(() => {
        const fetchMargin = async () => {
            try {
                const result = await apiCall("margin", {}, true);
                if (result.status === true) {
                    const prepaidOperators = result.margin.filter(item => item.category === "Prepaid");
                    const dthOperators = result.margin.filter(item => item.category === "DTH");

                    setMobileOperators(prepaidOperators);
                    setDthOperators(dthOperators);
                } else {
                    toast.error(result.message || "An error occurred. Please try again.");
                }
            } catch (error) {
                toast.error("Network error. Please try again.");
            } finally {
                setLoading(false);
            }
        }
        fetchMargin();
    }, [])

    const formatCommission = (commission, commissionType) => {
        if (!commission) return "0%";
        if (commissionType === "1") {
            return `${commission}%`;
        }
        return `₹${commission}`;
    };

    if (loading) {
        return (
            <>
                <Header title={"Margin"} showBack={true} />
                <div className="text-center py-12">
                    <div className="w-10 h-10 rounded-full animate-spin mx-auto mb-4" style={{ border: `3px solid ${APP_THEME.primaryColor}33`, borderTopColor: APP_THEME.primaryColor }} />
                    <div className="text-sm font-medium" style={{ color: APP_THEME.textSecondary, fontFamily: APP_THEME.fontFamily }}>
                        Loading margin...
                    </div>
                </div>
                <BottomNav />
                <Toaster position="bottom-center" />
            </>
        );
    }

    return (
        <>
            <Header title={"Margin"} showBack={true} />
            <div className="page-enter px-4 pb-24">
                {/* Mobile Recharge Section */}
                {mobileOperators.length > 0 && (
                    <div className="mt-4">
                        <h3 className="text-sm font-bold uppercase tracking-wide mb-3" style={{ color: APP_THEME.textSecondary }}>
                            Mobile Recharge
                        </h3>
                        <div className="rounded-xl overflow-hidden" style={{ background: APP_THEME.surfaceColor, border: `1px solid ${APP_THEME.borderColor}` }}>
                            {mobileOperators.map((item, index) => (
                                <div
                                    key={item.operator_id}
                                    className={`flex items-center justify-between p-4 ${index !== mobileOperators.length - 1 ? 'border-b' : ''
                                        }`}
                                    style={{ borderBottomColor: index !== mobileOperators.length - 1 ? APP_THEME.borderColor : 'transparent' }}
                                >
                                    <div className="flex items-center gap-3">
                                        <div className="w-8 h-8 rounded-full overflow-hidden flex items-center justify-center" style={{ background: APP_THEME.bgColor, border: `1px solid ${APP_THEME.borderColor}` }}>
                                            <img src={item.logo} alt={item.biller_name} className="w-full h-full object-contain" />
                                        </div>
                                        <span className="text-sm font-bold" style={{ color: APP_THEME.textPrimary }}>
                                            {item.biller_name}
                                        </span>
                                    </div>
                                    <div className="flex items-center gap-1.5">
                                        <span className="text-base font-extrabold" style={{ color: APP_THEME.primaryColor }}>
                                            {formatCommission(item.commission, item.commission_type)}
                                        </span>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                )}

                {/* DTH Recharge Section */}
                {dthOperators.length > 0 && (
                    <div className="mt-6">
                        <h3 className="text-sm font-bold uppercase tracking-wide mb-3" style={{ color: APP_THEME.textSecondary }}>
                            DTH Recharge
                        </h3>
                        <div className="rounded-xl overflow-hidden" style={{ background: APP_THEME.surfaceColor, border: `1px solid ${APP_THEME.borderColor}` }}>
                            {dthOperators.map((item, index) => (
                                <div
                                    key={item.operator_id}
                                    className={`flex items-center justify-between p-4 ${index !== dthOperators.length - 1 ? 'border-b' : ''
                                        }`}
                                    style={{ borderBottomColor: index !== dthOperators.length - 1 ? APP_THEME.borderColor : 'transparent' }}
                                >
                                    <div className="flex items-center gap-3">
                                        <div className="w-8 h-8 rounded-lg overflow-hidden flex items-center justify-center" style={{ background: APP_THEME.primaryLight, border: `1px solid ${APP_THEME.borderColor}` }}>
                                            <img src={item.logo} alt={item.biller_name} className="w-full h-full object-contain" />
                                        </div>
                                        <span className="text-sm font-semibold" style={{ color: APP_THEME.textPrimary }}>
                                            {item.biller_name}
                                        </span>
                                    </div>
                                    <span className="text-sm font-bold" style={{ color: APP_THEME.primaryColor }}>
                                        {formatCommission(item.commission, item.commission_type)}
                                    </span>
                                </div>
                            ))}
                        </div>
                    </div>
                )}

                {/* Show message if no data */}
                {mobileOperators.length === 0 && dthOperators.length === 0 && (
                    <div className="text-center mt-12" style={{ color: APP_THEME.textSecondary }}>
                        No margin data available
                    </div>
                )}
            </div>
            <BottomNav />
            <Toaster position="bottom-center" />
        </>
    );
}

export default Margin;